import React from 'react'

class CardSubmitActions extends React.Component {
  designer(){
    const designer_roles = [
        'ad_designer',
        'creative_director',
        'pub_designer',
        'store_designer',
        'digital_designer',
        'digital_creative_director',
      ];

    return designer_roles.includes(this.props.roleType);
  }

  render() {
    const approveIconKlass = this.props.resolved ? 'green-text text-accent-4' : 'grey-text';
    const disabled = this.props.resolved ? 'disabled' : 'cursor-pointer'
    const submittable = this.props.resolved ? null : this.props.onSubmit

    const attach = this.designer() ? (
      <span>
        <input type='file' className='hidden js-attach-file' onChange={this.props.onFileUpload} accept=".png,.jpg,.jpeg"/>
        <i className={`material-icons grey-text rotate-90 ${disabled}`} style={{ 'fontSize': '20px'}} onClick={this.props.onAttach}>attach_file</i>
      </span>
    ) : null;

    return this.props.readOnly ? null : (
      <div className="d-flex flex-row pt-1 pb-2">
        <div className="d-flex flex-column col text-center pr-0 pl-1">
          <i className={`material-icons cursor-pointer ${approveIconKlass}`} style={{ 'fontSize': '20px'}} onClick={this.props.onResolve}>check_circle</i>
        </div>
        <div className="d-flex flex-column col text-left pl-0" style={{ 'marginLeft': '-15px'}}>
          {attach}
        </div>
        <div className="d-flex flex-column col-5"></div>
        <div className="d-flex flex-column col-2">
          <i className={`material-icons grey-text ${disabled}`} style={{ 'fontSize': '20px'}} onClick={submittable}>send</i>
        </div>
      </div>
    )
  }
}

export default CardSubmitActions
